import { Link } from "@remix-run/react";
import {
  IconLayoutSidebar,
  IconLayoutSidebarRightFilled,
} from "@tabler/icons-react";
import { useTranslation } from "react-i18next";

import { Button } from "#app/components/ui/button";
import { Icon } from "#app/components/ui/icon";
import { RailTooltip } from "#app/components/ui/tooltip";
import { cn } from "#app/utils/misc.tsx";

type MainLogoProps = {
  collapsed: boolean;
  onToggle: () => void;
  onNavigate: (to: string) => void;
};

export function MainLogo({ collapsed, onToggle, onNavigate }: MainLogoProps) {
  const { t } = useTranslation(["nav", "common"]);

  const toggleLabel = collapsed
    ? t("common:ui.openSidebar")
    : t("common:ui.closeSidebar");

  return (
    <div className="group relative flex h-10 items-center justify-between">
      <Link
        to="/u/dashboard"
        onClick={(event) => {
          event.preventDefault();
          onNavigate("/u/dashboard");
        }}
        className="flex items-center overflow-hidden"
      >
        <Icon name="supervity" className="h-6 w-6 shrink-0 dark:hidden" />
        <img
          src="/img/supervity-logo-dark.png"
          alt=""
          className="hidden h-6 w-6 shrink-0 dark:block"
        />

        <span
          className={cn(
            "ml-2 overflow-hidden text-lg font-medium whitespace-nowrap transition-all duration-200",
            collapsed ? "w-0 opacity-0" : "w-auto opacity-100",
          )}
        >
          {t("common:brandAuto")}
        </span>
      </Link>

      <RailTooltip title={toggleLabel}>
        <Button
          variant="ghost"
          size="icon-lg"
          onClick={onToggle}
          aria-label={toggleLabel}
          className={cn(
            collapsed &&
              "absolute top-0 -left-2 opacity-0 group-hover:opacity-100 hidden sm:flex",
          )}
        >
          {collapsed ? (
            <IconLayoutSidebarRightFilled className="size-5" />
          ) : (
            <IconLayoutSidebar className="size-5" />
          )}
        </Button>
      </RailTooltip>
    </div>
  );
}

export default MainLogo;
